/* eslint-disable no-underscore-dangle,no-useless-constructor,no-console */
/* eslint-disable graphql/template-strings */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// global variables
import { adStatus, rules } from 'config';
// our components
import { AD_QUERY } from 'components/Ad/Details';
import ReviewRulesDetails from 'components/ReviewRules/Details/Details';
import { Query, Mutation } from 'components/common/Query';
import { bulkUpdate } from 'helpers/updateMutationsHelper';
import RouterContext from 'helpers/routerContext';

const AD_FRAGMENT = `
  fragment fragmentAd on AdminAdType {
    id
    title
    description
    price
    currency
    subcategory {
      id
      title
      parentCategory {
        id
        title
      }
    }
    user {
      id
      fullname
      email
      phone
    }
    images {
      id
      lastStatus
      status
      urls {
        thumb
        high
      }
    }
    readyImages {
      id
      urls {
        high
        thumb
      }
    }
    reviewed
    reviewedOn
    updatedOn
    updatedOnByUser
    updatedOnToOrder
    reviewedBy {
      id
      fullname
    }
    isAuto
    matchedRules
    name
    firstPhone
    firstPhonePrefix
    firstPhoneType
    secondPhone
    secondPhonePrefix
    secondPhoneType
    whatsapp
    email
    status
    flagCount    
    botScoreInsert
    botScoreUpdate
    ipInsert
    ipUpdate
    updateCount
    countryInsert
    countryUpdate
    province {
      name
    }
    municipality {
      name
    }
  }
`;

const SIMILARITY_AD_FRAGMENT = `
  fragment fragmentSimilarityAd on SimilarityAdType { 
      id
      title
      description
      price
      currency
      subcategory {
        id
        title
        parentCategory {
          id
          title
        }
      }
      user {
        id
        fullname
        email
        phone
      }
      images {
        id
        lastStatus
        status
        urls {
          thumb
          high
        }
      }
      readyImages {
        id
        urls {
          high
          thumb
        }
      }
      reviewed
      reviewedOn
      updatedOn
      updatedOnByUser
      updatedOnToOrder
      reviewedBy {
        id
        fullname
      }
      isAuto
      matchedRules
      name
      firstPhone
      firstPhonePrefix
      firstPhoneType
      secondPhone
      secondPhonePrefix
      secondPhoneType
      whatsapp
      email
      status
      flagCount    
      botScoreInsert
      botScoreUpdate
      ipInsert
      ipUpdate
      updateCount
      countryInsert
      countryUpdate
      score
      province {
        name
      }
      municipality {
        name
      }
  }
`;

/**
 * Query to fetch ads from api
 */
export const SIMILARITY_ADS_QUERY = gql`
  query SimilarityAds($id: Int!) {
    similarityAds(id: $id) {
      ...fragmentSimilarityAd
    }
  }
  ${SIMILARITY_AD_FRAGMENT}
`;

/**
 * Query to fetch ads from api
 */
export const SIMILARITY_REINSERT_ADS_QUERY = gql`
  query SimilarityReinsertAds($id: Int!) {
    similarityReinsert(id: $id) {
      ...fragmentSimilarityAd
    }
  }
  ${SIMILARITY_AD_FRAGMENT}
`;

/**
 * Query to fetch ads from api
 */
export const IP_RATE_LIMIT_ADS_QUERY = gql`
  query IpRateLimitAds($id: Int!) {
    ipRateLimitAds(id: $id) {
      ...fragmentAd
    }
  }
  ${AD_FRAGMENT}
`;

/**
 * Query to fetch ads from api
 */
export const BOT_SCORE_RELATED_ADS_QUERY = gql`
  query BotScoreRelatedAds($id: Int!) {
    botScoreRelatedAds(id: $id) {
      ...fragmentAd
    }
  }
  ${AD_FRAGMENT}
`;

/**
 * Query to fetch ads from api
 */
export const SAME_OWNER_ADS_QUERY = gql`
  query AdminAdsList($sameOwnerAds: ID) {
    ads(sameOwnerAds: $sameOwnerAds) {
      edges {
        node {
          ...fragmentAd
        }
      }
    }
  }
  ${AD_FRAGMENT}
`;

/**
 * Query to fetch ads from api
 */
export const DUPLICATED_IMAGES_ADS_QUERY = gql`
  query AdminAdsList($idIn: [ID]) {
    ads(idIn: $idIn) {
      edges {
        node {
          ...fragmentAd
        }
      }
    }
  }
  ${AD_FRAGMENT}
`;

/**
 * Query to fetch ads from api
 */
export const USER_RATE_LIMIT_ADS = gql`
  query UserRateLimitAds($id: Int!) {
    userRateLimitAds(id: $id) {
      ...fragmentAd
    }
  }
  ${AD_FRAGMENT}
`;

/**
 * Query to fetch categories from api
 */
export const CATEGORIES_QUERY = gql`
  query {
    categories {
      id
      title
      subcategories {
        id
        title
      }
    }
  }
`;

/**
 * Mutation to change ad category
 */
export const CHANGE_AD_CATEGORY_MUTATION = gql`
  mutation($id: ID!, $subcategoryId: ID!) {
    changeAdCategory(input: { id: $id, subcategory: $subcategoryId }) {
      ad {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Mutation to publish ads
 */
export const PUBLISH_ADS_MUTATION = gql`
  mutation($ids: [ID]!) {
    publishAd(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;
/**
 * Mutation to publish ads
 */
export const UNPUBLISH_ADS_MUTATION = gql`
  mutation($ids: [ID]!) {
    unPublishAd(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * @class
 * @description ReviewRules Details Component
 * @augments Component
 */
class ReviewRulesDetailsContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      itemProcessing: [],
      failedIds: [],
      showNotification: false,
      query: this.getQueryInfo(),
    };
    this.Compose = adopt({
      mutateAdPublishBaseAd: this.adPublishBaseAd,
      mutateAdUnPublishBaseAd: this.adUnPublishBaseAd,
      mutateAdPublish: this.adPublish,
      mutateAdUnPublish: this.adUnPublish,
      mutateAdChangeCategory: this.adChangeCategory,
      queryAds: this.listAds,
      queryBaseAd: this.baseAd,
      queryCategories: this.listCategories,
    });
    this.fetchMoreAds = () => {};
    this.fetchMore = () => {};
  }

  /**
   * @description
   * Obtain query info based on the current rule in review.
   *
   * @returns {Object} Query info .
   */
  getQueryInfo = () => {
    const { rule, id } = this.props;
    let queryInfo;
    switch (rule) {
      case rules.SIMILARITY: {
        queryInfo = {
          label: SIMILARITY_ADS_QUERY,
          name: 'similarityAds',
          variables: { id },
          typename: 'SimilarityAdType',
        };
        break;
      }
      case rules.SIMILARITY_REINSERT: {
        queryInfo = {
          label: SIMILARITY_REINSERT_ADS_QUERY,
          name: 'similarityReinsert',
          variables: { id },
          typename: 'SimilarityAdType',
        };
        break;
      }
      case rules.IP_RATE_LIMIT: {
        queryInfo = {
          label: IP_RATE_LIMIT_ADS_QUERY,
          name: 'ipRateLimitAds',
          variables: { id },
          typename: 'AdminAdType',
        };
        break;
      }
      case rules.BOT_SCORE_RELATED: {
        queryInfo = {
          label: BOT_SCORE_RELATED_ADS_QUERY,
          name: 'botScoreRelatedAds',
          variables: { id },
          typename: 'AdminAdType',
        };
        break;
      }
      case rules.FLAGGED_FREQUENCY: {
        queryInfo = {
          label: SAME_OWNER_ADS_QUERY,
          name: 'ads',
          variables: { sameOwnerAds: id },
          typename: 'AdminAdType',
        };
        break;
      }
      case rules.FLAGGED_COUNT: {
        queryInfo = {
          label: SAME_OWNER_ADS_QUERY,
          name: 'ads',
          variables: { sameOwnerAds: id },
          typename: 'AdminAdType',
        };
        break;
      }
      case rules.DUPLICATED_IMAGES: {
        queryInfo = {
          label: DUPLICATED_IMAGES_ADS_QUERY,
          name: 'ads',
          variables: {
            idIn: decodeURIComponent(id)
              .split(',')
              .slice(1),
          },
          typename: 'AdminAdType',
        };
        break;
      }
      case rules.USER_RATE_LIMIT: {
        queryInfo = {
          label: USER_RATE_LIMIT_ADS,
          name: 'userRateLimitAds',
          variables: { id },
          typename: 'AdminAdType',
        };
        break;
      }
      case rules.REVIEW_CATEGORY: {
        queryInfo = {
          label: DUPLICATED_IMAGES_ADS_QUERY,
          name: 'ads',
          variables: { idIn: [id] },
          typename: 'AdminAdType',
        };
        break;
      }
      default: {
        queryInfo = {};
        break;
      }
    }
    return queryInfo;
  };

  /**
   * @description
   * Query callback to compose with mutations.
   *
   * @param {*} render - Query's render props.
   * @returns {*} Query component.
   */
  listAds = ({ render }) => {
    const { query } = this.state;
    return (
      <Query
        query={query.label}
        variables={query.variables}
        notifyOnNetworkStatusChange
        fetchPolicy="cache-and-network"
      >
        {({ data, loading, fetchMore }) => {
          this.fetchMoreAds = fetchMore;
          return render({
            data,
            loadingAds: loading,
            fetchMore,
          });
        }}
      </Query>
    );
  };

  /**
   * @description
   * User's query callback to compose with mutations.
   *
   * @param {*} render - Query's render props.
   * @returns {*} Query component.
   */
  baseAd = ({ render }) => {
    const { rule } = this.props;
    let { id } = this.props;

    if (rule === rules.DUPLICATED_IMAGES || rule === rules.REVIEW_CATEGORY) {
      [id] = decodeURIComponent(id).split(',');
    }

    return (
      <Query
        query={AD_QUERY}
        variables={{ id }}
        notifyOnNetworkStatusChange
        fetchPolicy="cache-and-network"
      >
        {({ data, fetchMore }) => {
          this.fetchMore = fetchMore;
          return render({ ad: data });
        }}
      </Query>
    );
  };

  /**
   * @description
   * Query callback to compose with categories.
   *
   * @param {*} render - Query's render props.
   * @returns {*} Query component.
   */
  listCategories = ({ render }) => {
    const { rule } = this.props;

    return (
      <Query
        query={CATEGORIES_QUERY}
        variables={{}}
        skip={rule !== rules.REVIEW_CATEGORY}
        notifyOnNetworkStatusChange
      >
        {({ data, loading }) =>
          render({ categoriesData: data, loadingCategories: loading })
        }
      </Query>
    );
  };

  /**
   * @description
   * Mutation to change ad category.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adChangeCategory = ({ render }) => (
    <Mutation mutation={CHANGE_AD_CATEGORY_MUTATION}>
      {(handleAdChangeCategory, { loading }) =>
        render({
          handleAdChangeCategory,
          loadingAdChangeCategory: loading,
        })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation publish callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adPublish = ({ render }) => {
    const { itemProcessing, query } = this.state;
    return (
      <Mutation
        mutation={PUBLISH_ADS_MUTATION}
        onCompleted={this.mutationCompleted('publishAd', itemProcessing)}
        update={(cache, { data: { publishAd } }) => {
          const data = {
            status: adStatus.PUBLISHED_BY_MODERATOR,
            __typename: query.typename,
          };

          bulkUpdate(
            cache,
            query.typename,
            'Publish',
            'status',
            data,
            publishAd.successIds,
          );
        }}
      >
        {(handleAdPublish, { loading }) =>
          render({ handleAdPublish, loadingAdPublish: loading })
        }
      </Mutation>
    );
  };

  /**
   * @description
   * Mutation publish callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adPublishBaseAd = ({ render }) => (
    <Mutation
      mutation={PUBLISH_ADS_MUTATION}
      update={(cache, { data: { publishAd } }) => {
        const data = {
          status: adStatus.PUBLISHED_BY_MODERATOR,
          __typename: 'AdminAdType',
        };

        bulkUpdate(
          cache,
          'AdminAdType',
          'Publish',
          'status',
          data,
          publishAd.successIds,
        );
      }}
    >
      {(handleAdPublishBaseAd, { loading }) =>
        render({ handleAdPublishBaseAd, loadingAdPublishBaseAd: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation unpublish callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adUnPublish = ({ render }) => {
    const { itemProcessing, query } = this.state;
    return (
      <Mutation
        mutation={UNPUBLISH_ADS_MUTATION}
        onCompleted={this.mutationCompleted('unPublishAd', itemProcessing)}
        update={(cache, { data: { unPublishAd } }) => {
          const data = {
            status: adStatus.UNPUBLISHED_BY_MODERATOR,
            __typename: query.typename,
          };

          bulkUpdate(
            cache,
            query.typename,
            'Unpublish',
            'status',
            data,
            unPublishAd.successIds,
          );
        }}
      >
        {(handleAdUnPublish, { loading }) =>
          render({ handleAdUnPublish, loadingAdUnPublish: loading })
        }
      </Mutation>
    );
  };

  /**
   * @description
   * Mutation unpublish callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adUnPublishBaseAd = ({ render }) => (
    <Mutation
      mutation={UNPUBLISH_ADS_MUTATION}
      update={(cache, { data: { unPublishAd } }) => {
        const data = {
          status: adStatus.UNPUBLISHED_BY_MODERATOR,
          __typename: 'AdminAdType',
        };

        bulkUpdate(
          cache,
          'AdminAdType',
          'Unpublish',
          'status',
          data,
          unPublishAd.successIds,
        );
      }}
    >
      {(handleAdUnPublishBaseAd, { loading }) =>
        render({ handleAdUnPublishBaseAd, loadingAdUnPublishBaseAd: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * OnComplete publish or unpublish mutation.
   *
   * @param {Object} field - Target field of mutation.
   * @param {Object} itemProcessing - Ids of items that is processing.
   * @returns {undefined} - No returns value.
   */
  mutationCompleted = (field, itemProcessing) => async data => {
    const failedIds = itemProcessing.filter(
      item => !data[field].successIds.includes(item),
    );
    this.setState({
      itemProcessing: [],
      failedIds,
      showNotification: failedIds.length > 0,
    });
  };

  /**
   * @description
   * Refresh the list.
   * @returns {Function} - Fetch More function.
   */
  handleRefresh = () => {
    this.fetchMoreAds({
      updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
    });
    this.fetchMore({
      updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
    });
  };

  /**
   * @description
   * Close notification.
   * @returns {undefined} - No returns value.
   */
  handleCloseNotification = () => {
    this.setState({ showNotification: false });
  };

  /**
   * @description
   * Format data based on current rule.
   * @param {Object} data - Query data from api.
   * @returns {Array} - Formatted data.
   */
  formatDataBasedOnRule = data => {
    const { query } = this.state;
    const { rule } = this.props;
    if (
      rule === rules.FLAGGED_COUNT ||
      rule === rules.FLAGGED_FREQUENCY ||
      rule === rules.DUPLICATED_IMAGES ||
      rule === rules.REVIEW_CATEGORY
    ) {
      return data[query.name].edges.map(edge => ({ ...edge.node }));
    }
    return data[query.name];
  };

  /**
   * @description
   * Render ReviewRulesDetails component.
   *
   * @returns {undefined} - No returns.
   */
  render() {
    const { itemProcessing, failedIds, showNotification } = this.state;
    const { rule } = this.props;
    return (
      <this.Compose>
        {({
          mutateAdPublish: { handleAdPublish },
          mutateAdPublishBaseAd: {
            handleAdPublishBaseAd,
            loadingAdPublishBaseAd,
          },
          mutateAdUnPublish: { handleAdUnPublish },
          mutateAdChangeCategory: {
            handleAdChangeCategory,
            loadingAdChangeCategory,
          },
          mutateAdUnPublishBaseAd: {
            handleAdUnPublishBaseAd,
            loadingAdUnPublishBaseAd,
          },
          queryBaseAd: { ad },
          queryAds: { data, loadingAds },
          queryCategories: { categoriesData },
        }) => (
          <React.Fragment>
            <ReviewRulesDetails
              rule={rule}
              categories={categoriesData ? categoriesData.categories : []}
              data={
                data && Object.keys(data).length > 0
                  ? this.formatDataBasedOnRule(data)
                  : []
              }
              baseAd={ad}
              adPublish={items => {
                this.setState({
                  itemProcessing: [...itemProcessing, ...items],
                  failedIds: [],
                });
                handleAdPublish({ variables: { ids: items } });
              }}
              adPublishBaseAd={items => {
                handleAdPublishBaseAd({ variables: { ids: items } });
              }}
              adUnPublish={items => {
                this.setState({
                  itemProcessing: [...itemProcessing, ...items],
                  failedIds: [],
                });
                handleAdUnPublish({ variables: { ids: items } });
              }}
              adUnPublishBaseAd={items => {
                handleAdUnPublishBaseAd({ variables: { ids: items } });
              }}
              adApplyRuleAndPublish={(items, subcategoryId) => {
                if (!items || items.length === 0 || !subcategoryId) {
                  return Promise.resolve();
                }
                return handleAdChangeCategory({
                  variables: { id: items[0], subcategoryId },
                }).then(() =>
                  handleAdPublish({
                    variables: { ids: items },
                  }),
                );
              }}
              adApplyRuleAndPublishBaseAd={subcategoryId => {
                if (!ad.ad || !ad.ad.id || !subcategoryId) {
                  return Promise.resolve();
                }
                return handleAdChangeCategory({
                  variables: { id: ad.ad.id, subcategoryId },
                }).then(() =>
                  handleAdPublishBaseAd({
                    variables: { ids: [ad.ad.id] },
                  }),
                );
              }}
              refresh={this.handleRefresh}
              fullLoading={loadingAds}
              adActionLoadingBaseAd={
                loadingAdPublishBaseAd ||
                loadingAdUnPublishBaseAd ||
                loadingAdChangeCategory
              }
              itemProcessing={itemProcessing}
              loading={!data || Object.keys(data).length === 0}
              failedIds={failedIds}
              showNotification={showNotification}
              closeNotification={this.handleCloseNotification}
            />
          </React.Fragment>
        )}
      </this.Compose>
    );
  }
}

/**
 * ReviewRulesDetailsContainer PropTypes
 * @param rule - prop to know what rule is reviewing
 * @param id - prop to know id of the base Ad
 */

ReviewRulesDetailsContainer.propTypes = {
  rule: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default ReviewRulesDetailsContainer;
